import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { emptyUserEntitlements, UserEntitlements, UserEntitlementService } from '@ddv/entitlements';
import { InitializationErrorCollectorService } from '@ddv/navigation';
import { catchError, Observable, of } from 'rxjs';

export const userEntitlementsResolver: ResolveFn<UserEntitlements> = (route): Observable<UserEntitlements> => {
    const errorCollector = inject(InitializationErrorCollectorService);
    const service = inject(UserEntitlementService);

    const clientCode = route.paramMap.get('clientCode') ?? '';
    return service.fetchUserEntitlements(clientCode)
        .pipe(catchError((error) => {
            errorCollector.addError(`Failed to load user entitlements for client ${clientCode}`, error);
            return of(emptyUserEntitlements());
        }));
};
